import { Instagram, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { INSTAGRAM_IMAGES, STUDIO } from "../data/siteContent";

export default function InstagramStrip() {
  return (
    <section data-testid="instagram-section" className="pb-20 sm:pb-28 lg:pb-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="flex flex-col sm:flex-row items-center justify-between gap-4 mb-8 sm:mb-10">
          <div className="flex items-center gap-4">
            <span className="w-11 h-11 border border-gold/40 flex items-center justify-center text-gold">
              <Instagram className="w-5 h-5" />
            </span>
            <div>
              <p className="font-display text-xl sm:text-2xl text-ivory">Follow the journey</p>
              <p className="text-xs uppercase tracking-[0.22em] text-ivory-mute mt-0.5">
                Fresh weddings, behind-the-scenes & reels
              </p>
            </div>
          </div>
          <a
            data-testid="instagram-follow-btn"
            href={STUDIO.instagram.url}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 text-[12px] font-semibold uppercase tracking-[0.2em] bg-gold text-ink px-7 py-3.5 hover:bg-gold-hover transition-colors"
          >
            {STUDIO.instagram.handle}
            <ArrowUpRight className="w-4 h-4" />
          </a>
        </Reveal>

        <div className="grid grid-cols-4 md:grid-cols-8 gap-1.5 sm:gap-2">
          {INSTAGRAM_IMAGES.map((src, i) => (
            <Reveal key={src} delay={i * 0.05}>
              <a
                data-testid={`instagram-tile-${i + 1}`}
                href={STUDIO.instagram.url}
                target="_blank"
                rel="noreferrer"
                className="group relative block aspect-square overflow-hidden"
              >
                <img
                  src={src}
                  alt={`Mohit Studio Instagram — wedding moment ${i + 1}`}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <span className="absolute inset-0 bg-ink/60 opacity-0 group-hover:opacity-100 transition-opacity duration-400 flex items-center justify-center text-ivory">
                  <Instagram className="w-5 h-5" />
                </span>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
